module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lt":{"headline":"Saulės elektrinių įranga","subHeadlineInverters":"Inverteriai (įtampos keitikliai)","text":"Saulės modulių kaina sudaro apie 40-50 % saulės elektrinės kainos, todėl į jų kokybę kreipiamas didžiausias dėmesys. Siūlome saulės modulius iš Tier1 sąrašo, kuri sudaro „Bloomberg New Energy Finance“.","linkDescription":"Naujausias Tier1 gamintojų sąrašas: ","linkText":"čia"}}')
  delete Component.options._Ctor
}
